module.exports = __webpack_public_path__ + "assets/icons/table-sortable.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/svg/table-sortable.svg
// module id = NboS
// module chunks = 1